import React, { ChangeEventHandler, ComponentPropsWithoutRef } from 'react'
import { useTranslation } from 'react-i18next';
import { MultiSelect as BaseCompoenent, Option } from "react-multi-select-component";
import { Close } from 'src/icons/icons';

export const MultiSelect = ({ isLoading, labelledBy = '' , value = [], options = [], ...props }: { isLoading?: boolean, options: Option[] } & ComponentPropsWithoutRef<typeof BaseCompoenent>) => {

    const { t } = useTranslation()
    return (
        <>
            <BaseCompoenent

                hasSelectAll={false}
                isLoading={isLoading}
                labelledBy={labelledBy}
                options={options}
                value={value}
                // ItemRenderer={()}

                className='text-sm text-gray-800 rounded-lg relative'
                ClearIcon={<div className='mr-auto absolute text-red top-1/2 right-56  -translate-y-1/2'><Close color='red' /></div>}
                overrideStrings={{ selectSomeItems: t('select'), search: t('search'), noOptions: t('noOptions'), allItemsAreSelected: t('allItemsAreSelected') }}
                ItemRenderer={({ checked,
                    option,
                    onClick,
                    disabled, }: { checked: boolean, disabled: boolean, onClick: ChangeEventHandler<HTMLInputElement>, option: { label: string, value: string } }) => <div style={{ display: 'flex', alignItems: 'center' }} className={`item-renderer  gap-2 items-center ${disabled ? "disabled" : ""}`}>
                        <input
                            type="checkbox"
                            onChange={onClick}
                            checked={checked}
                            className='rounded'
                            tabIndex={-1}
                            disabled={disabled}
                        />
                        <div  >{option.label}</div>
                    </div>}
                {...props}

            // labelledBy="Select"
            />
        </>
    )
}
